const getters = {
  highSearch: state => state.search.highSearch,
  searchHint: state => state.search.searchHint,
  listCatalogName: state => state.search.listCatalogName,
  listTagName: state => state.search.listTagName,
  listCompname: state => state.search.listCompname,
  openUrl: state => state.search.openUrl,
  dataBase: state => state.search.dataBase
}

export default getters
